import React from 'react';
import { withRouter } from 'react-router-dom';

import BI from 'big-integer';
import RTZ from 'remove-trailing-zeros'

import './MobileSwapOrderBox.css';

class MobileSwapOrderBox extends React.Component {
  constructor(props) {
    super(props);
  }

  CC_fullzero = (val) => {
    val = String(val);
    let temp = BI(val).divmod("1000000000000000000");
    let apt = temp.remainder.toString();
    let aptLen = apt.length;

    for(let i = 0; i < 18 - aptLen; i++) {
      apt = "0" + apt;
    }

    let xpt = [temp.quotient.toString(), apt]
    return xpt[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (xpt[1] ? "." + xpt[1] : "");
  }

  CC = (val) => {
    val = String(val);
    let temp = BI(val).divmod("1000000000000000000");
    let apt = temp.remainder.toString();
    let aptLen = apt.length;

    for(let i = 0; i < 18 - aptLen; i++) {
      apt = "0" + apt;
    }

    let xpt = [temp.quotient.toString(), apt]
    return RTZ(xpt[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (xpt[1] ? "." + xpt[1] : ""));
  }

  redirect = (boxInfo) => {
    this.props.history.push('/swap/' + boxInfo.tokenNameFrom + '-' + boxInfo.tokenNameTo + '/' + this.props.swapData.swapOrderID);
  }
  redirectCreateSwap = (boxInfo) => {
    this.props.history.push('/createswap/' + boxInfo.tokenNameTo + '-' + boxInfo.tokenNameFrom);
    //this.props.history.push('/createswap/' + boxInfo.tokenNameFrom + '-' + boxInfo.tokenNameTo);
  }
  
  render() {
    let boxInfo = {
      tokenNameFrom: "APIX",
      tokenNameTo: "APIX",
      tokenIconFrom: "tokenicon_apix.svg",
      tokenIconTo: "tokenicon_apix.svg",
    }

    if(this.props.swapPair === 0) {
      boxInfo = {
        tokenNameFrom: "APIX",
        tokenNameTo: "wDASH",
        tokenIconFrom: "tokenicon_apix.svg",
        tokenIconTo: "tokenicon_dash.svg",
      }
    } else if(this.props.swapPair === 1) {
      boxInfo = {
        tokenNameFrom: "APIX",
        tokenNameTo: "wXZC",
        tokenIconFrom: "tokenicon_apix.svg",
        tokenIconTo: "tokenicon_xzc.svg",
      }
    } else if(this.props.swapPair === 2) {
      boxInfo = {
        tokenNameFrom: "wDASH",
        tokenNameTo: "APIX",
        tokenIconFrom: "tokenicon_dash.svg",
        tokenIconTo: "tokenicon_apix.svg",
      }
    } else if(this.props.swapPair === 3) {
      boxInfo = {
        tokenNameFrom: "wDASH",
        tokenNameTo: "wXZC",
        tokenIconFrom: "tokenicon_dash.svg",
        tokenIconTo: "tokenicon_xzc.svg",
      }
    } else if(this.props.swapPair === 4) {
      boxInfo = {
        tokenNameFrom: "wXZC",
        tokenNameTo: "APIX",
        tokenIconFrom: "tokenicon_xzc.svg",
        tokenIconTo: "tokenicon_apix.svg",
      }
    } else if(this.props.swapPair === 5) {
      boxInfo = {
        tokenNameFrom: "wXZC",
        tokenNameTo: "wDASH",
        tokenIconFrom: "tokenicon_xzc.svg",
        tokenIconTo: "tokenicon_dash.svg",
      }
    }

    if(this.props.swapData === null) { //create swap - inverted data display
      return(
        <div className="mobile-mobile-swap-create-box">
          <div className="mobile-swap-order-box-top">
            <div className="mobile-swap-order-box-top-img">
              <img className="mobile-swap-order-box-icon-from" src={require("../../Asset/" + boxInfo.tokenIconFrom)}/>
              <img className="mobile-swap-order-box-icon-to" src={require("../../Asset/" + boxInfo.tokenIconTo)}/>
            </div>
          </div>
          <div className="mobile-swap-order-box-bottom">
            <div className="mobile-swap-order-box-bottom-1">
              <p className="mobile-swap-order-box-pair">{boxInfo.tokenNameFrom} - {boxInfo.tokenNameTo}</p>
              <p className="mobile-swap-order-box-pair">New Swap Creatable</p>
            </div>
            <div className="mobile-swap-order-box-bottom-3">
              <button className="mobile-swap-order-box-swapbutton" onClick={()=>{this.redirectCreateSwap(boxInfo)}}>
                Create Swap
              </button>
            </div>
          </div>
        </div>
      )
    }

    let ftr = Number(Number(this.props.swapData.toTokenAmount)/Number(this.props.swapData.fromTokenAmount)).toFixed(2); //from : 1 - to : ftr
    let tfr = Number(Number(this.props.swapData.fromTokenAmount)/Number(this.props.swapData.toTokenAmount)).toFixed(2); //to : 1 - from : tfr

    if(this.props.swapData.isSwapCancelled) { //cancelled swap
      return (
        <div className="mobile-swap-order-box-finished">
          <div className="mobile-swap-order-box-top">
            <div className="mobile-swap-order-box-top-img">
              <img className="mobile-swap-order-box-icon-from" src={require("../../Asset/" + boxInfo.tokenIconFrom)}/>
              <img className="mobile-swap-order-box-icon-to" src={require("../../Asset/" + boxInfo.tokenIconTo)}/>
            </div>
            <div className="mobile-swap-order-box-top-id">
              {boxInfo.tokenNameFrom}-{boxInfo.tokenNameTo}-v1-{this.props.swapData.swapOrderID}
            </div>
            <div className="mobile-swap-order-box-top-tag-finished">
              Cancelled
            </div>
          </div>
          <div className="mobile-swap-order-box-bottom">
            <div className="mobile-swap-order-box-bottom-1">
              <p className="mobile-swap-order-box-lot">
                Swap <span className="mobile-swap-order-box-num">{this.CC(this.props.swapData.fromTokenAmount)}</span> {boxInfo.tokenNameFrom}<br/>
                To <span className="mobile-swap-order-box-num">{this.CC(this.props.swapData.toTokenAmount)}</span> {boxInfo.tokenNameTo}
              </p>
              <p className="mobile-swap-order-box-ratio">
                ( 1 {boxInfo.tokenNameFrom} : {ftr} {boxInfo.tokenNameTo} , 1 {boxInfo.tokenNameTo} : {tfr} {boxInfo.tokenNameFrom} )
              </p>
            </div>
          </div>
        </div>
      )
    } else if(this.props.swapData.isSwapFinished || (!this.props.swapData.isSwapOpened)) { //closed swap
      return (
        <div className="mobile-swap-order-box-finished">
          <div className="mobile-swap-order-box-top">
            <div className="mobile-swap-order-box-top-img">
              <img className="mobile-swap-order-box-icon-from" src={require("../../Asset/" + boxInfo.tokenIconFrom)}/>
              <img className="mobile-swap-order-box-icon-to" src={require("../../Asset/" + boxInfo.tokenIconTo)}/>
            </div>
            <div className="mobile-swap-order-box-top-id">
              {boxInfo.tokenNameFrom}-{boxInfo.tokenNameTo}-v1-{this.props.swapData.swapOrderID}
            </div>
            <div className="mobile-swap-order-box-top-tag-finished">
              Finished
            </div>
          </div>
          <div className="mobile-swap-order-box-bottom">
            <div className="mobile-swap-order-box-bottom-1">
              <p className="mobile-swap-order-box-lot">
                Swap <span className="mobile-swap-order-box-num">{this.CC(this.props.swapData.fromTokenAmount)}</span> {boxInfo.tokenNameFrom}<br/>
                To <span className="mobile-swap-order-box-num">{this.CC(this.props.swapData.toTokenAmount)}</span> {boxInfo.tokenNameTo}
              </p>
              <p className="mobile-swap-order-box-ratio">
                ( 1 {boxInfo.tokenNameFrom} : {ftr} {boxInfo.tokenNameTo} , 1 {boxInfo.tokenNameTo} : {tfr} {boxInfo.tokenNameFrom} )
              </p>
            </div>
          </div>
        </div>
      )
    } else {
      return (
        <div className="mobile-swap-order-box" onClick={()=>{this.redirect(boxInfo)}}>
          <div className="mobile-swap-order-box-top">
            <div className="mobile-swap-order-box-top-img">
              <img className="mobile-swap-order-box-icon-from" src={require("../../Asset/" + boxInfo.tokenIconFrom)}/>
              <img className="mobile-swap-order-box-icon-to" src={require("../../Asset/" + boxInfo.tokenIconTo)}/>
            </div>
            <div className="mobile-swap-order-box-top-id">
              {boxInfo.tokenNameFrom}-{boxInfo.tokenNameTo}-v1-{this.props.swapData.swapOrderID}
            </div>
            <div className="mobile-swap-order-box-top-tag-available">
              Available
            </div>
          </div>
          <div className="mobile-swap-order-box-bottom">
            <div className="mobile-swap-order-box-bottom-1">
              <p className="mobile-swap-order-box-lot">
                Swap <span className="mobile-swap-order-box-num">{this.CC(this.props.swapData.fromTokenAmount)}</span> {boxInfo.tokenNameFrom}<br/>
                To <span className="mobile-swap-order-box-num">{this.CC(this.props.swapData.toTokenAmount)}</span> {boxInfo.tokenNameTo}
              </p>
              <p className="mobile-swap-order-box-ratio">
                ( 1 {boxInfo.tokenNameFrom} : {ftr} {boxInfo.tokenNameTo} , 1 {boxInfo.tokenNameTo} : {tfr} {boxInfo.tokenNameFrom} )
              </p>
            </div>
          </div>
        </div>
      ) 
    }
  }
}

export default withRouter(MobileSwapOrderBox);


//fromTokenAmount: "50161000000"
//isSwapCancelled: false
//isSwapFinished: false
//isSwapOpened: true
//swapCreator: "0x8CAd9B4941aAfb67b5A5e6DeA657Db2d4ea7b757"
//swapOrderID: "1"
//swapTaker: "0x0000000000000000000000000000000000000000"
//toTokenAmount: "1561630000"